<template>
  <div>
    <div v-if="!editShow">
      {{ value }}
      <i
        v-if="!disabled"
        :class="$style.click"
        class="el-icon-edit"
        @click="onEdit"
      ></i>
    </div>
    <div :class="$style.edit" v-else>
      <el-input-number
        v-if="type === 'number'"
        size="mini"
        v-model="inputValue"
        v-bind="{
          style: 'width: 80px;',
          ...inputProps,
        }"
        @keyup.enter.native="submit"
      ></el-input-number>
      <el-input
        v-else
        v-model="inputValue"
        v-bind="{
          style: 'width: 80px;',
          ...inputProps,
        }"
        @keyup.enter.native="submit"
      ></el-input>
      <i :class="$style.click" class="el-icon-check" @click="submit"></i>
      <i
        :class="$style.click"
        class="el-icon-close"
        @click="onClose"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpanEdit',
  props: {
    value: [String, Number],
    type: String,
    inputProps: {
      type: Object,
      default: () => {}
    },
    beforeEdit: Function,
    beforeSubmit: Function,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      editShow: false,
      loading: false,
      inputValue: '',
    };
  },
  methods: {
    async onEdit () {
      let res = true
      if (this.beforeEdit) {
        res = await this.beforeEdit()
      }
      if (res) {
        this.inputValue = this.value
        this.editShow = true
      }
    },
    async submit () {
      if (this.inputValue === this.value) {
        this.onClose()
        return
      }
      let res = true
      if (this.beforeSubmit) {
        res = await this.beforeSubmit(this.inputValue, this.value)
      }
      if (res) {
        this.onClose()
        this.$emit('input', this.inputValue)
        this.$emit('submit', this.inputValue, this.value)
      }
    },
    onClose () {
      this.editShow = false
    }
  }
}
</script>

<style style="scss" module>
.click {
  cursor: pointer;
}
.edit {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>